import script from "./CustomerShowButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerShowButtons.vue?vue&type=script&setup=true&lang=js"

import "./CustomerShowButtons.vue?vue&type=style&index=0&id=0f96586c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f96586c"]])

export default __exports__